export function LoanOfficerCardSkeleton() {
  return (
    <div className="lo-card__container lo-card__container--skeleton" data-testid="lo-card-skeleton" aria-busy="true">
      <div className="lo-card__wrapper">
        <div className="lo-card__skeleton-image" />
        <div className="lo-card__skeleton-content">
          <div className="lo-card__skeleton-line lo-card__skeleton-line--name" />
          <div className="lo-card__skeleton-line lo-card__skeleton-line--title" />
          <div className="lo-card__skeleton-line lo-card__skeleton-line--contact" />
        </div>
      </div>
    </div>
  );
}

export function LoanOfficerCardV2Skeleton() {
  return (
    <div className="lo-card-v2 lo-card-v2--skeleton" data-testid="lo-card-v2-skeleton" aria-busy="true">
      <div className="lo-card-v2__info">
        <div className="lo-card-v2__skeleton-avatar" />
        <div className="lo-card-v2__skeleton-line lo-card-v2__skeleton-line--name" />
        <div className="lo-card-v2__skeleton-line lo-card-v2__skeleton-line--title" />
        <div className="lo-card-v2__skeleton-line lo-card-v2__skeleton-line--nmls" />
      </div>
      <div className="lo-card-v2__skeleton-contact" />
    </div>
  );
}
